import React, { useState, useEffect } from 'react';
// styles
import useStyles from './styles';
import { useHistory } from 'react-router-dom';
import {List, ListItem, ListItemIcon,ListItemText, Button,Checkbox, Typography, Grid,Paper} from '@material-ui/core';
// TabPanel, Accordion
import { ControlledAccordions } from '..';
import { validateForm } from '../../common/utils';
import BrandLogo from "../BrandLogo";
import {FormInput} from "../";
import {toast} from "react-toastify";
import ConvertSuccessModal from './components/ConvertSuccessModal';
import { pathOr, clone } from 'ramda';
import { useSelector } from 'react-redux';

const handleCheck = (data, val) => {
	return data.some((item) => val === item.type);
};
const setValues = (attributes, initialState, fieldState) => {
	attributes.map((rowField) => {
		rowField.map((field) => {
			return (
					field.name ? (initialState[field.name] = field.value ? field.value : '') : null,
					field.name ? (fieldState[field.name] = field) : null
				);
		});
	});
};
const ConvertLeadView = ({ id, data, module, onSubmit }) => {
	let [initialValues, setInitialValues] = useState({});
	const [fields, setFields] = useState({});
	const [errors, setErrors] = useState({});
	const [moveToActivity, setMoveToActivity] = useState({});

	const [modalVisible, setModalVisible] = useState(false);
	// const [Linedata,setLineData] = useState();
	const classes = useStyles();
	const history = useHistory();
	const { userPreference,config } = useSelector((state) => state.config);
    const calendar_format = pathOr(config.default_date_format, ['attributes', 'global','calendar_format'], userPreference);
	const date_reg_format = pathOr(config.default_date_format, ['attributes', 'global','date_reg_format'], userPreference);
	const time_reg_format = pathOr(config.default_date_format, ['attributes', 'global','time_reg_format'], userPreference);
	const date_reg_positions = pathOr(config.default_date_format, ['attributes', 'global','date_reg_positions'], userPreference);
	//var isTab = handleCheck(data, 'tab');
	const getFieldArr = (module)=>{
		return {
			moduel:module,
			id_name:(module==='Contacts')?'reports_to_id':'account_id',
			type:'relate',
			field_key:(module==='Contacts')?'report_to_name':'account_name',
			name:(module==='Contacts')?'report_to_name':'account_name',
			label:`Select ${module}`
		};
	}

	var isTab = false;
	useEffect(
		() => {
			// {
			let initialState = [];
			let fieldState = [];
			initialState.lead_conv_ac_op_sel_options={};
			Object.keys(data).map((row) => {
				setValues(data[row].attributes, initialState, fieldState);
				data[row].panels &&
					data[row].panels.map((panelRow) => {
						setValues(panelRow.attributes, initialState, fieldState);
					});
				//console.log("hiii row 1",row);
				if(data[row].copyData)
				{
					setMoveToActivity({...moveToActivity,[data[row].module]:data[row].module});
					initialState['new'+data[row].module] = true;
					initialState.lead_conv_ac_op_sel_options={...initialState.lead_conv_ac_op_sel_options,[data[row].module]:data[row].module}
				}
				if(data[row].module=='Contacts' || data[row].module=='Accounts')
				{
					initialState['convert_create_'+data[row].module] = true;
				}				
			});
			initialValues = initialState;
			// setInitialValues(initialState );
			setFields(fieldState);
			setInitialValues({ ...initialValues, ...initialState });

			// }
		},
		[data]
	);

	//console.log("rowFieldrowField data", data)

	const handleDateTimeChange = (date) => {
		let current_datetime = new Date(date);
		return current_datetime.getFullYear() + "-" + ("0" + (current_datetime.getMonth() + 1)).slice(-2) + "-" + ("0" + current_datetime.getDate()).slice(-2) + " " + ("0" + current_datetime.getHours()).slice(-2) + ":" + ("0" + current_datetime.getMinutes()).slice(-2) + ":" + ("0" + current_datetime.getSeconds()).slice(-2)
	};

	const getFormatedValue = (initialValuesArr) => {
		let init = initialValuesArr;
		for (let key in init) {
			if (typeof init[key] === "object" && key !== 'line_items') {
				init = { ...init, ...init[key] }
			}
			if (key.includes('date')) {
				let formatedDate = handleDateTimeChange(init[key]);
				init = { ...init, [key]: formatedDate }
			}
		}
		setInitialValues(init);
		return init;
	}

	const onChange = (field, value) => {
		//console.log(field)
		//console.log(value)
		if (field.type === "relate") {
			setInitialValues({ ...initialValues, [field.name]: value.value, [field.id_name]: value.id });
			return;
		}
		if (field.type === 'newCheckBtn') {
			if (value===true) {
				initialValues['convert_create_'+field.value] = true;
				initialValues['new'+field.value] = true;				
				initialValues['lead_conv_ac_op_sel_options']={...initialValues['lead_conv_ac_op_sel_options'],[field.value]:field.value}
			}else{
				initialValues['new'+field.value] = false;
				delete initialValues['lead_conv_ac_op_sel_options'][field.value];
			}
		}

		initialValues[field.name] = value
		setInitialValues({ ...initialValues, [field.name]: value });
		//console.log("initialValues",initialValues);
	};

	const handleSubmit = (event) => {
		event.preventDefault();
		let newFieldArr = [];
		let newInitialValuesArr = {};
		let fieldsArr  = clone(fields);
		let initialValuesArr  = clone(initialValues);
		let availableModules = initialValuesArr.lead_conv_ac_op_sel_options;
		
		//toast("Please fill all the required fields!"); return;
		delete initialValuesArr.lead_conv_ac_op_sel_options;
		///console.log("initialValues.lead_conv_ac_op_sel_options",initialValues.lead_conv_ac_op_sel_options);
		Object.entries(availableModules).map((module,key)=>{
			//console.log("module",module);
			Object.entries(fieldsArr).map((field,fieldKey)=>{
				// console.log("field",field);
				// console.log("fieldKey",fieldKey);
				// console.log("module",module[0]);
				if(field[0].startsWith(module[0]))
				{
					//let arr = {[field[0]]:field[1]};
					newFieldArr[field[0]]=field[1];
				}
			});
			initialValuesArr['new'+module[0]] = (initialValuesArr['new'+module[0]]==true)?'on':'';
			initialValuesArr['convert_create_'+module[0]] = (initialValuesArr['new'+module[0]]=='on')?'true':'';
		});
		if(!initialValuesArr.newContacts)
		{
			let report_to_name = {};
			report_to_name.value = (initialValuesArr['report_to_name'])?initialValuesArr['report_to_name']:null;
			report_to_name.name = 'report_to_name';
			report_to_name.required = 'true';
			report_to_name.type = 'relate';
			report_to_name.label = 'Contacts';
			newFieldArr.report_to_name=report_to_name;
			//newFieldArr.push({"report_to_name":report_to_name});
		}
		if(!initialValuesArr.newAccounts)
		{
			let account_name = {};
			account_name.value = (initialValuesArr['account_name'])?initialValuesArr['account_name']:null;
			account_name.name = 'account_name';
			account_name.required = 'true';
			account_name.type = 'relate';
			account_name.label = 'Accounts';
			newFieldArr.account_name=account_name;
			//newFieldArr.push({"account_name":account_name});
		}
		
		let validate = validateForm(newFieldArr, initialValuesArr,{ calendar_format, date_reg_format, time_reg_format, date_reg_positions });
		setErrors(validate.errors);
		// console.log("initialValuesArr",initialValuesArr);
		// console.log("newFieldArr",newFieldArr);
		// console.log("validate",validate);
		 //return;
		 //console.log("validate.errors",validate.errors);
		 //console.log("fields",fields);
		 //console.log("newFieldArr",newFieldArr);
		//  console.log("initialValues",initialValues);
		  //console.log("initialValuesArr",initialValuesArr);
			//return;
		if (validate.formIsValid) {
			var submitData = {
				data: {
					module: module,
					record: id,
					action:"ConvertLead",
					...getFormatedValue(initialValuesArr)
				}
			};
			//console.log("Submit DAta");
			//console.log(submitData);
			
			onSubmit(submitData);
			
		}else{
			toast("Please fill all the required fields!");
		}
	};
	
	const renderRelateFields = (row)=>{
		return (
			<>
			<Grid container
			direction="row"
			justify="space-between"
			alignItems="left"
			spacing="2">
				<Grid item sm={4}>
				{
					(row.module==='Contacts' || row.module==='Accounts')?(<Typography variant="subtitle2">{row.label} {(!initialValues['new'+row.module] && !initialValues['new'+row.module]===true)?`OR Select ${row.module}`:''}</Typography>):<Typography variant="subtitle2">{row.label}</Typography>
				}					
				</Grid>
				{
				((!initialValues['new'+row.module] && !initialValues['new'+row.module]===true) && (row.module==='Contacts' || row.module==='Accounts'))?(
				<Grid item sm={4}>
					<FormInput
						field={getFieldArr(row.module)}
						initialValues={initialValues}
						value={""}
						errors={errors}
						module={row.module}
						small={true}
						onChange={(val) => onChange(getFieldArr(row.module), val)}
						disabled={true}
					/>
				</Grid>):''
				}
				<Grid item sm={4}></Grid>
			</Grid>
			</>
		);
	}

	return (
		<div className={classes.root}>
			<form onSubmit={handleSubmit} className={classes.root} noValidate autoComplete="off">
				<Paper className={classes.paper}>
					{/* <Typography gutterBottom variant="subtitle1">
										{id ? 'Edit ' : 'Create '}
										{module}
									</Typography> */}
					<Grid container direction="row" justify="space-between" alignItems="center"spacing="2">
						<Grid item>
							<Button type="submit" variant="contained" size="small" color="primary">Save</Button>
							<Button variant="contained" size="small" color="primary" onClick={history.goBack} className={classes.margin}>Cancel</Button>
						</Grid>
						<Grid item style={{ marginTop: '-15px' }}>
							<BrandLogo />
						</Grid>
					</Grid>
				</Paper>

				<Paper className={classes.paperEdit}>
					<Grid container spacing={2}>
						<Grid item xs={12} sm container>
							<List
							component="nav"
							aria-labelledby="nested-list-subheader"
							className={classes.root}>								
								{data.map((row,key)=>(
								<>
								<ListItem >
									<ListItemIcon>
										<Checkbox edge="start" value={'new'+row.module} checked={(initialValues['new'+row.module] && initialValues['new'+row.module]===true)?true:false} tabIndex={-1} name={'new'+row.module} disableRipple onChange={(e)=>onChange({type:'newCheckBtn',value:row.module,name:'new'+row.module},e.target.checked)} />
									</ListItemIcon>
									<ListItemText primary={renderRelateFields(row)} />
								</ListItem>
								<ListItem>
									{
										(initialValues['new'+row.module] && initialValues['new'+row.module]===true)?
										<ControlledAccordions
										data={[row]}
										errors={errors}
										initialValues={initialValues}
										module={module}
										headerBackground="true"
										onChange={onChange}
										isExpanded={true}
										hiddenAll={{hidden:[],disabled:[]}}
										/>:''
									}
								</ListItem>
								</>
							))}
							
							</List>
							<Grid container
							direction="row"
							justify="space-between"
							alignItems="left"
							spacing="2">
								<Grid item sm={3}>
									<Typography variant="subtitle2">Move Activities to:</Typography>
								</Grid>								
								<Grid item sm={3}>
									<FormInput
										field={{type:'enum',name:'lead_conv_ac_op_sel',label:``,options:initialValues['lead_conv_ac_op_sel_options']}}
										initialValues={initialValues}
										
										errors={errors}
										value={initialValues['lead_conv_ac_op_sel']?initialValues['lead_conv_ac_op_sel']:''}
										small={true}
										onChange={(val) => onChange({type:'enum',name:'lead_conv_ac_op_sel',label:``,options:initialValues['lead_conv_ac_op_sel_options']}, val)}
										disabled={true}
									/>
								</Grid>
								<Grid item sm={6}></Grid>
								</Grid>
							{/* {isTab ? (
								initialValues ? <TabPanel
									data={data}
									errors={errors}
									initialValues={initialValues}
									module={module}
									onChange={onChange}
								/> : null
							) : (
									initialValues ? '' : null
								)} */}
						</Grid>
					</Grid>
				</Paper>
			</form>
			{modalVisible && (
                <ConvertSuccessModal
                  modalVisible={modalVisible}
                  toggleModalVisibility={() =>
                    setModalVisible(!modalVisible)
                  } 
				  data={[]}                 	                  
				  id={id}
				  history={history}
                />
              )}
		</div>
	);
};

export default ConvertLeadView;
